import React from "react";

function MuteIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 419 512.5"
      className={className}
    >
      <path
        fillRule="nonzero"
        d="M302.29 90.86v137.26c0 5.01-.32 9.78-.89 14.36L143.48 54.63c29.13-83.38 158.81-71.32 158.81 36.23zM6.28 58.21c-9.51-11.31-8.05-28.19 3.26-37.7 11.31-9.51 28.19-8.05 37.7 3.26l90.46 107.6v-.45l138.05 164.22-.21.19 40.39 48.05.21-.2 26.35 31.34-.21.2 70.44 83.79c9.51 11.31 8.05 28.2-3.26 37.71-11.31 9.51-28.19 8.05-37.7-3.26l-73.73-87.71-3.25 1.55a177.508 177.508 0 01-54.36 15.29v69.98c0 5.63-2.3 10.75-5.99 14.44a20.394 20.394 0 01-14.44 5.99c-5.63 0-10.74-2.3-14.43-5.99a20.394 20.394 0 01-5.99-14.44v-69.98a176.994 176.994 0 01-54.33-15.31c-19.31-8.94-36.77-21.22-51.61-36.06l-.35-.38c-16.37-16.45-29.58-36.04-38.61-57.73a177.451 177.451 0 01-13.61-68.25c0-5.6 2.3-10.72 6-14.42 3.68-3.7 8.79-6 14.42-6 5.64 0 10.75 2.3 14.44 5.99l.41.45c3.46 3.65 5.58 8.59 5.58 13.98 0 18.62 3.74 36.4 10.49 52.62 7.03 16.89 17.33 32.13 30.09 44.89 12.78 12.76 28.02 23.08 44.88 30.09a136.933 136.933 0 0052.62 10.49c17.89 0 35.01-3.45 50.71-9.71l-47.35-56.32c-42.23 1.66-85.65-27.78-85.65-88.3v-13.59L6.28 58.21zm341.19 239.07l.12-.3c6.75-16.22 10.49-34 10.49-52.62 0-5.63 2.3-10.75 5.99-14.44 3.69-3.69 8.8-5.98 14.43-5.98 5.63 0 10.75 2.29 14.44 5.98l.41.45c3.45 3.66 5.58 8.59 5.58 13.99a177.694 177.694 0 01-22.75 87.08l-28.71-34.16z"
      ></path>
    </svg>
  );
}

export default MuteIcon;
